import { render, staticRenderFns } from "./DayTemplateMenu.vue?vue&type=template&id=5777cce4&scoped=true&"
import script from "./DayTemplateMenu.vue?vue&type=script&lang=js&"
export * from "./DayTemplateMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777cce4",
  null
  
)

export default component.exports